import { BillingProvider } from './constants';

class BillingError extends Error {
  constructor(msg, { code, info, provider = BillingProvider.CHARGEBEE } = {}) {
    super(msg);
    this.info = {
      ...info,
      provider,
    };
    this.code = code;
    this.log = true;
  }
}

export default BillingError;
